import { createAction } from 'redux-actions';
import { REMOVE_FILE_UPLOAD } from '../constants/actionTypes';
export const removeFileUpload = createAction(REMOVE_FILE_UPLOAD, ({
  fileUpload
}) => ({
  fileUpload
}));